import React, { Fragment } from 'react';
import I18n from '../../config/locales/e_i18n';
import queryString from 'query-string';
import { setToken } from '../../utils/helper';
import { Route } from 'react-router-dom';
const Layout = ({ children }) => {
  return <Fragment>{children}</Fragment>;
};

class ExternalLayout extends React.Component {
  constructor(props) {
    super(props);

    const { search } = props.location;
    const { locale = '',token ='' } = queryString.parse(search);
    if (token ) {
      setToken(token);
    }
    I18n.defaultLocale = 'en';
    I18n.locale = locale || '';
    I18n.fallbacks = true;
  }

  componentDidMount = () => {
    let value = document.getElementById('feedbackButton');
    if (value) {
      value.classList.add('force-display-none');
    }
  };

  render() {
    const { component: Component, ...rest } = this.props;
    return (
      <Route
        {...rest}
        render={matchProps => (
          <Layout>
            <Component {...matchProps} fromIFrame={origin === 'iframe'} />
          </Layout>
        )}
      />
    );
  }
}

export default ExternalLayout;
